import styled from '@emotion/styled'

import Button from '@segment/matcha/components/Button'

import Typography from '@segment/matcha/components/Typography'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import LogoTiles from '@segment/templates/LogoTiles'

import { trackButtonClick } from '@segment/tracking/scripts'

import useStartupLinks from '@segment/utils/useStartupLinks'

const copy = {
  heading: `Join the Segment Startup Program to access our full deal book`,
}

const button = {
  text: `Apply now`,
}

const SignUp = () => {
  const { applyLink } = useStartupLinks()

  return (
    <Wrapper>
      <StyledSectionBase variant="centered">
        <StyledTypography variant="h2">{copy.heading}</StyledTypography>
        <Button
          color="primary"
          variant="filled"
          size="large"
          href={applyLink}
          onClick={() => trackButtonClick({ buttonText: button.text, targetUrl: applyLink })}
        >
          {button.text}
        </Button>
      </StyledSectionBase>
      <LogoTiles />
    </Wrapper>
  )
}

const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.palette.twilio.gray[10]};
`

const StyledTypography = styled(Typography)`
  text-align: center;
  max-width: 684px;
  margin: 0;
`

const StyledSectionBase = styled(SectionBase)`
  ${Section.Wrapper} {
    padding-top: 80px;
    row-gap: 40px;

    ${({ theme }) => theme.breakpoints.up(`md`)} {
      padding-top: 160px;
    }
  }
`

export default SignUp
